import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { logError } from "@/lib/logError";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    logError(location.pathname, { where: "404 Error: User attempted to access non-existent route" });

    // Add noindex meta tag to prevent Google from indexing 404 pages (avoids soft 404 issues)
    const metaRobots = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (metaRobots) {
      metaRobots.content = 'noindex';
    } else {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex';
      document.head.appendChild(meta);
    }

    return () => {
      // Restore default robots on unmount
      const meta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
      if (meta) {
        meta.content = 'index, follow';
      }
    };
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-muted-foreground mb-4">Oops! Page not found</p>
        <p className="text-muted-foreground">
          Go Grab a Burger or{" "}
          <Link to="/" className="text-primary hover:text-primary-hover underline">
            Return to Home
          </Link>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
